/* eslint-disable */

import React from 'react';
import * as SVGs from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/components/dev-page/style/components/all-svgs.css';

const SVG = ({
  SVGName,
}) => {

  const SVGToRender = SVGs[SVGName];
  return (
    <SVGToRender />
  )
}

const AllSvgs = () => {
  const listOfSVGs = Object.keys(SVGs);
  return (
    <React.Fragment>
      <h3>All Svgs:</h3>
      <div className="all-svgs">
        {
          listOfSVGs.map((SVGName, i) => (
            <div className="svg-example" key={SVGName}>
              <div className="svg-name-wrapper">
                <h5 className="svg-name">{SVGName}</h5>
              </div>
              <div className="svg-example-box">
                <div className="svg-example-box-background">
                  <SVG
                    SVGName={SVGName}
                  />
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </React.Fragment>
  );
}

export { AllSvgs };
